export default "__VITE_ASSET__CJ_3WwKc__"